module.exports = __webpack_public_path__ + "img/LamdeiniLearning-147.0c2caa0f.jpg";